

module.exports = __webpack_require__.stylable.create(
    "PendingGroupActions2893886520",
    {"classes":{"root":"PendingGroupActions2893886520__root","actionButton":"PendingGroupActions2893886520__actionButton"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "PendingGroupActions2893886520",
    null
);
